export default __webpack_public_path__ + "static/media/material-products-solid.e0313d3e.svg";